export default function isIE() {
  const agent = navigator.userAgent.toLowerCase();

  return (navigator.appName === 'Netscape' && agent.includes('trident')) || agent.includes('msie');
}
